import { useLocation } from "react-router-dom";
import Header from "../view/components/header/Header";
import Sidebar from "../view/components/sidebar/Sidebar";
import {
  ACCOUNT_STATEMENT_ROUTE,
  AFFILIATE_PROGRAM_ROUTE,
  BONUS_STATEMENT_ROUTE,
  DASHBOARD_ROUTE,
  HOME_ROUTE,
  IN_PLAY_ROUTE,
  MY_BETS_ROUTE,
  MY_PROFILE_ROUTE,
  MY_TRANSACTION_ROUTE,
  MY_WALLET_ROUTE,
  PROFIT_LOSS_REPORT_ROUTE,
  RootState,
  RULES_ROUTE,
  STAKE_SETTINGS_ROUTE,
  TURNOVER_REPORT_ROUTE,
} from "@hypexone/uicore";
import MobileFooter from "../view/components/mobile-footer/MobileFooter";
import UserRouter from "../view/components/routes/UserRouter";
import OpenBets from "../view/components/open-bets/OpenBets";
import { connect } from "react-redux";
const AppLayout = ({ balance, exposure, loggedIn }) => {
  const pathName = useLocation().pathname;
  const isHomePage = pathName.includes(`${HOME_ROUTE}`);
  const isInplayRoute = pathName.includes(`${IN_PLAY_ROUTE}`);

  const isUserMenuPages =
    pathName.includes(ACCOUNT_STATEMENT_ROUTE) ||
    pathName.includes(PROFIT_LOSS_REPORT_ROUTE) ||
    pathName.includes(AFFILIATE_PROGRAM_ROUTE) ||
    pathName.includes(RULES_ROUTE) ||
    pathName.includes(MY_BETS_ROUTE) ||
    pathName.includes(MY_WALLET_ROUTE) ||
    pathName.includes(TURNOVER_REPORT_ROUTE) ||
    pathName.includes(BONUS_STATEMENT_ROUTE) ||
    pathName.includes(MY_TRANSACTION_ROUTE) ||
    pathName.includes(STAKE_SETTINGS_ROUTE) ||
    pathName.includes(MY_PROFILE_ROUTE) ||
    pathName.includes("transactions") ||
    // TODO: UI core
    pathName.includes("/deposit-turnover") ||
    pathName.includes("/change-password") ||
    pathName.includes("/bonus_rewards") ||
    pathName.includes("/promotions");

  const disableSportsSubheader =
    pathName.startsWith("exchange_sports") || pathName === DASHBOARD_ROUTE;

  return (
    <div className="h-screen flex flex-col gap-[1px]">
      <Header disableSportsSubheader={disableSportsSubheader} loggedIn={loggedIn} exposure={exposure} balance={balance}  />

      <div className="flex-1 flex white bg-gray1">
        {/* Sidebar */}
        {!isHomePage && !isInplayRoute && (
          <div className="bg-white w-[15%] min-w-60 h-full hidden md:block overflow-auto hide-scrollbar shadow-md z-30">
            <Sidebar />
          </div>
        )}

        {/* Pages */}
        <div
          className={`h-full w-full overflow-auto hide-scrollbar mb-6 md:mb-0 md:px-2 md:pl-[15px] md:pr-3`}
        >
          <UserRouter />
        </div>

        {!isHomePage && !isUserMenuPages && (
          <div className="bg-white border border-gray6 w-[20%] min-w-[330px] hidden md:block h-full">
            <OpenBets />
          </div>
        )}
      </div>
      <div className="md:hidden">
        <MobileFooter />
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    balance: state.auth.balanceSummary.balance,
    exposure: state.auth.balanceSummary.exposure,
        loggedIn: state.auth.loggedIn,
  };
};



export default connect(mapStateToProps, null)(AppLayout);